import { blockUI } from 'angular';

import { BursonOrderLineModel }   from './models/burson.order-line';
import { BursonOrderStatusModel } from './models/burson.order-status';
import { BursonServiceAjs }       from './burson.service.ajs';
import { PurchaseOrderModel }     from '../purchase-orders/models/purchase-order';

interface ResolveBursonOrderFailuresScope extends ng.IScope {
  block            : blockUI.BlockUIService;
  failures         : Array<BursonOrderLineModel>;
  forceOrder       : () => void;
  isOrderInvalid   : () => boolean;
  order            : PurchaseOrderModel;
  resubmit         : () => void;
  tableSettings    : any;
}

export function ResolveBursonOrderFailuresCtrl (
  $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
  $scope           : ResolveBursonOrderFailuresScope,
  $translate       : ng.translate.ITranslateService,
  blockUI          : any,
  bursonApi        : BursonServiceAjs,
  failures         : Array<BursonOrderLineModel>,
  messages         : any,
  order            : PurchaseOrderModel
) {
  $scope.block     = blockUI.instances.get('bursonOrderFailuresBlock');
  $scope.failures  = failures;
  $scope.order     = order;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'all-caps',
        field  : 'item_code',
        header : {
          text: $translate.instant('PRODUCT_SPACE.ITEM_CODE')
        }
      },
      {
        field : 'reason',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        classes: 'text-right',
        field  : 'qty',
        header : {
          classes: 'text-right',
          text   : $translate.instant('PRODUCT_SPACE.QTY')
        },
        pipe: 'number',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.forceOrder = function () {
    $scope.block.start();

    bursonApi.sendOrder($scope.order, { force: true })
    .then(() => {
      $uibModalInstance.close(true);
    })
    .catch(err => {
      messages.error(err);

      return bursonApi.checkOrderStatus($scope.order);
    })
    .then(( status : BursonOrderStatusModel ) => {
      if (status.failed_items.length) {
        $scope.failures = status.failed_items;
      }
      else if (!status.order_parts.length) {
        $uibModalInstance.dismiss();
      }
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.isOrderInvalid = function () {
    return bursonApi.isOrderInvalid($scope.failures);
  };

  $scope.resubmit = function () {
    $scope.block.start();

    bursonApi.sendOrder($scope.order, {
      failures: $scope.failures
    })
    .then(() => {
      $uibModalInstance.close(true);
    })
    .catch(err => {
      messages.error(err);

      return bursonApi.checkOrderStatus($scope.order);
    })
    .then(( status : BursonOrderStatusModel ) => {
      if (status.failed_items.length) {
        $scope.failures = status.failed_items;
      }
      else if (!status.order_parts.length) {
        $uibModalInstance.dismiss();
      }
    })
    .finally(() => {
      $scope.block.stop();
    });
  };
};
